var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-standard-description"},[_c('div',{staticClass:"stream-standatd-description-body",domProps:{"innerHTML":_vm._s(_vm.handleNewLine(_vm.params.bodyText))}}),(_vm.componentIndex === _vm.activeComponent)?_c('RemoveItem',{nativeOn:{"click":function($event){return _vm.removeComponent(_vm.componentIndex)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }